module.exports = __webpack_public_path__ + "static/media/spot.97157b65.svg";